import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Efter lancering',
  subtitle: 'Se data fra Go Live-tjeklisten, og angiv datoen for screeningen efter lancering.',
  go_live_checklist: {
    labels: {
      yes: 'Ja',
      no: 'Nej',
    },
    title: 'Go Live-tjekliste',
    form: {
      is_google_business_available: {
        label: 'Google Business tilgængelig',
      },
      is_smart_pricing_configured: {
        label: 'Billigere priser end Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Kampagneflyer sendt',
      },
      is_menu_fully_configured: {
        label: 'Alle menupunkter er tilgængelige',
      },
      has_offers_on_competitor_platforms: {
        label: 'Kører restauranten tilbud på Wolt, Uber, Lieferando (undtagen tilbud om gratis levering)?',
      },
      is_instagram_story_shared: {
        label: 'Instagram-story delt med ejeren',
      },
      is_order_system_connected_to_website: {
        label: 'Foodamigos-websted forbundet ELLER restaurantens eget websted har fået en knap til onlinebestilling',
      },
      google_business_connected_by: {
        label: 'Hvordan fik vi adgang til Google Business-profilen?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Salgschef inviterede google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Salgschefen sendte selv den første anmodning fra ejerens telefon',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Onboarding-manager anmodede om Google Business-profil (salgschefen inviterede ikke og anmodede ikke om adgang)',
          null: 'I/T',
        },
      },
    },
    buttons: {
      save: 'Gem',
    },
    toasts: {
      success: 'Gemt',
      error: 'Kunne ikke gemme',
    },
  },
  post_launch_screening: {
    title: 'Screening efter lancering',
    form: {
      screening_date: {
        label: 'Screeningsdato',
      },
    },
    toasts: {
      success: 'Gemt',
      error: 'Kunne ikke gemme',
    },
    buttons: {
      save: 'Gem',
    },
  },
};
